var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 83,
    viewBox: "0 0 85 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_71_19)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 49,
    height: 47,
    rx: 11,
    fill: "#AE1916"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 17.5,
    width: 48,
    height: 46,
    rx: 10.5,
    stroke: "#AE1916"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 30C38.3358 30 38 30.3358 38 30.75V33H35.75C35.3358 33 35 33.3358 35 33.75V38.5145L33.5395 39.0493C33.3424 39.1214 33.1845 39.2729 33.1043 39.4669C33.0241 39.6608 33.0288 39.8795 33.1173 40.0699L35.4517 45.0879C35.6172 45.0333 35.7929 45.0029 35.9741 45.0002C36.5324 44.9919 37.0463 45.2489 37.3765 45.6692L34.8216 40.1772L41.4092 37.765C41.7931 37.6245 42.214 37.6227 42.599 37.7601L49.3744 40.1776L46.7524 45.5228C47.0809 45.189 47.5388 44.9917 48.0306 45.0003C48.2378 45.0039 48.4377 45.0438 48.6233 45.1146L51.0911 40.0838C51.1852 39.892 51.193 39.6691 51.1126 39.4711C51.0321 39.2732 50.8711 39.1189 50.6698 39.0471L49 38.4514V33.75C49 33.3358 48.6642 33 48.25 33H46V30.75C46 30.3358 45.6642 30 45.25 30H38.75ZM44.5 33H39.5V31.5H44.5V33ZM47.5 34.5V37.9162L43.1031 36.3473C42.3881 36.0922 41.6063 36.0954 40.8934 36.3565L36.5 37.9652V34.5H47.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7267 46.5635L48.7242 46.5548C48.6372 46.2324 48.3473 46.006 48.0131 46.0001C47.6782 45.9942 47.3801 46.2112 47.2826 46.5314L47.2822 46.5327L47.2791 46.5419C47.2753 46.5534 47.2686 46.573 47.2589 46.5997C47.2394 46.653 47.2079 46.7335 47.1635 46.832C47.0736 47.0309 46.9354 47.2925 46.7423 47.5496C46.3553 48.065 45.803 48.5 45 48.5C44.1969 48.5 43.6442 48.0649 43.2568 47.5494C43.0635 47.2922 42.9251 47.0306 42.8352 46.8317C42.7906 46.7332 42.7592 46.6527 42.7396 46.5993C42.7298 46.5727 42.7231 46.553 42.7193 46.5415L42.7162 46.5321C42.7161 46.5319 42.7162 46.5322 42.7162 46.5321C42.62 46.216 42.328 45.9995 41.9975 46C41.6671 46.0005 41.3759 46.2171 41.2805 46.5333L41.2802 46.5343L41.2772 46.5434C41.2735 46.5549 41.2668 46.5745 41.2571 46.6011C41.2378 46.6544 41.2066 46.7348 41.1623 46.8332C41.073 47.032 40.9354 47.2933 40.7429 47.5502C40.3573 48.0647 39.8055 48.5 39 48.5C38.1944 48.5 37.6422 48.0646 37.2562 47.55C37.0635 47.293 36.9258 47.0317 36.8363 46.8329C36.792 46.7344 36.7607 46.654 36.7413 46.6007C36.7316 46.5741 36.725 46.5545 36.7212 46.543L36.7175 46.5317C36.6203 46.2121 36.3232 45.9951 35.9889 46.0001C35.655 46.005 35.3647 46.2301 35.2766 46.552L35.274 46.561C35.2708 46.5713 35.2651 46.5896 35.2565 46.6149C35.2391 46.6656 35.2105 46.7432 35.1685 46.8386C35.0838 47.0312 34.9493 47.2859 34.7523 47.5373C34.3681 48.0273 33.7564 48.5 32.75 48.5C32.3358 48.5 32 48.8358 32 49.25C32 49.6642 32.3358 50 32.75 50C34.3236 50 35.3369 49.2227 35.9327 48.4627C35.9559 48.4332 35.9785 48.4036 36.0005 48.3741C36.0187 48.3994 36.0373 48.4247 36.0563 48.45C36.6078 49.1854 37.5556 50 39 50C40.4445 50 41.392 49.1853 41.9432 48.4498C41.9626 48.4239 41.9815 48.3981 42.0001 48.3723C42.0188 48.3983 42.038 48.4245 42.0577 48.4506C42.6097 49.1851 43.5576 50 45 50C46.4424 50 47.3901 49.185 47.9418 48.4504C47.9605 48.4253 47.9789 48.4004 47.9969 48.3754C48.0183 48.4042 48.0403 48.4331 48.0629 48.462C48.6583 49.2234 49.6722 50 51.25 50C51.6642 50 52 49.6642 52 49.25C52 48.8358 51.6642 48.5 51.25 48.5C50.2378 48.5 49.6267 48.0266 49.2446 47.538C49.0483 47.2871 48.9149 47.0328 48.8309 46.8405C48.7893 46.7453 48.761 46.6678 48.7439 46.6173C48.7354 46.5921 48.7298 46.5738 48.7267 46.5635Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_71_19",
    x: 0,
    y: 0,
    width: 85,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682353 0 0 0 0 0.0980392 0 0 0 0 0.0862745 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_19",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipCard);
export default __webpack_public_path__ + "static/media/ShipCard.0e3580045117f166ad85bf760aed723f.svg";
export { ForwardRef as ReactComponent };